import { render, staticRenderFns } from "./about02.vue?vue&type=template&id=da9855fe&scoped=true"
import script from "./about02.vue?vue&type=script&lang=js"
export * from "./about02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9855fe",
  null
  
)

export default component.exports